import { Pipe, PipeTransform } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";
import { AppStateInterface } from "src/app/stores/global/appState.interface";
import { employeesSelector } from "src/app/stores/global/employees/employees.store";

@Pipe({
    name: "user",
    standalone: false
})
export class UserPipe implements PipeTransform {
  constructor(private store: Store<AppStateInterface>) {}

  transform(userId: string): Observable<string> {
    return this.store.pipe(select(employeesSelector)).pipe(
      filter((employees) => employees.length > 0),
      map((employees) =>
        employees.find((employee) => employee.userId === userId)
      ),
      map((employee) => `${employee?.firstName} ${employee?.lastName}`)
    );
  }
}
